import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import {
  Portal,
  useBasketItemWithErrorList,
  OverflowHidden,
  useLocalLabels,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import { CheckoutLabels } from '../../checkout.props'
import {
  BasketPreviewItem,
  Spinner,
  ScrollView,
  Typography,
} from '../../../Common'

export const BasketItemsWithErrorsModal = () => {
  const { data } = useBasketItemWithErrorList()
  const labels = useLocalLabels<CheckoutLabels>()
  const [showSpinner, setShowSpinner] = useState(false)

  const globalLabels = useGlobalLabels()
  const [hasErrors, setHasErrors] = useState(false)
  const [canClose, setCanClose] = useState(false)
  const router = useRouter()
  useEffect(() => {
    if (!hasErrors && data?.length) {
      setHasErrors(true)
      return
    }

    if (!data?.length) {
      setCanClose(true)
    }
  }, [data, hasErrors])

  const close = () => {
    if (data?.length <= 1) {
      setShowSpinner(true)
      router.push('/')
    }
  }

  if (!hasErrors) return null

  return (
    <Portal>
      <Background>
        {!showSpinner ? (
          <Container>
            <ScrollView maxHeight="100%">
              <ItemsContainer canClose={canClose}>
                <Title>{labels?.outOfStockMessage}</Title>
                <div className="row g-4">
                  {data?.map((item) => (
                    <article
                      key={`Product__${item?._id}`}
                      className="col-12 px-3"
                    >
                      <BasketPreviewItem
                        productNumberLabel={globalLabels?.address?.number}
                        data={item}
                        close={close}
                      />
                    </article>
                  ))}
                </div>
              </ItemsContainer>
            </ScrollView>
          </Container>
        ) : (
          <LoaderContainer>
            <Spinner />
          </LoaderContainer>
        )}
      </Background>
      <OverflowHidden />
    </Portal>
  )
}
const LoaderContainer = styled.div.attrs({
  className: 'd-flex align-items-center justify-content-center',
})`
  height: 28rem;
  position: relative;
`

const Container = styled.div`
  --padding: 1.5rem;
  max-width: 110rem;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.palette.secondary};
  padding: var(--padding) 0 var(--padding) var(--padding);
  position: relative;

  @media (min-width: ${({ theme }) => theme.breakpoints.md.min}) {
    --padding: 3rem;
  }
`

const Title = styled(Typography).attrs({
  as: 'p',
  variant: 4,
})`
  text-align: center;
  background: ${({ theme }) => theme.palette.secondary};
  padding-bottom: var(--padding);
`

const ItemsContainer = styled.div<{ canClose?: boolean }>`
  padding-right: var(--padding);
  padding-bottom: ${(props) => (props.canClose ? '8rem' : 0)};
`

const Background = styled.div.attrs({
  className: 'd-flex align-items-center justify-content-center',
})`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 2rem;
  background: rgba(0, 0, 0, 0.3);
`
